import { useMoods } from "@/hooks/useMoods";

export function MoodDisplay() {
  const { recentMoods = [] } = useMoods();

  // Only show if there are moods
  if (!recentMoods || recentMoods.length === 0) return null;

  return (
    <div 
      className="flex flex-col items-center"
      title="Learners' moods"
    >
      <div className="flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-background/80 backdrop-blur-sm border shadow-sm">
        {recentMoods.map((mood, i) => (
          <span
            key={mood.id}
            className="text-xs leading-none"
            style={{ opacity: 1 - i * 0.12 }}
          >
            {mood.emoji}
          </span>
        ))}
      </div>
      <span className="text-[9px] text-primary/70 leading-none mt-1">learners mood</span>
    </div>
  );
}
